import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Constants, ProxyType } from 'src/app/helper/constants';
import { IProxyGroup, IGroupResult } from 'src/app/models/proxy-group';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProxyService {

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }

  private DefaultType = new BehaviorSubject(ProxyType.Individual);
  currentType = this.DefaultType.asObservable();

  createAndUpdateGroup = (group: IProxyGroup) => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IGroupResult>(Constants.PROXY_GROUP, group, options);
  }

  deleteProxy = (group: IProxyGroup[]) => {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: group
    };
    return this.httpClient.delete<IProxyGroup>(Constants.PROXY_GROUP, options);
  }

  getProxy = () => {
    return this.httpClient.get<IGroupResult>(Constants.PROXY_GROUP);
  }

  changeType(changeType: string) {
    this.DefaultType.next(changeType);
  }

}
